/**
 * This mixin adds functionality to a list of objects allowing
 * them to be "selected" or not
 */
import filterable from './filterable.mixin.js';

export default {
  mixins: [filterable],
  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    selectable: {
      type: Boolean,
    },
    maxSelections: {
      type: Number,
      default() {
        return 500;
      },
    },
    itemKey: {
      type: String,
      default() {
        return undefined;
      },
    },
    selectableId: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selected: [],
      snackbar: false,
      snackbarMessage: undefined,
      /*FIXME:
        This shouldn't be stored seperately, it should be a computed property
        based on `selected` value above which stores the list of IDs for items
        that are selected. Unfortunately, this array is getting mutated so it isn't
        easy to switch back.
        As a result of this issue, we now have to clear out both arrays or else the
        UI won't match up with the components internal state of selected items
      */
      selectedItems: [],
    };
  },
  computed: {
    partiallySelected() {
      return this.selected.length > 0;
    },
    allSelected() {
      return this.selected.length === this.filteredItems.length;
    },
  },
  watch: {
    selectedItems() {
      this.$emit('change-alert', this.selected);
    },
    selectableId() {
      if (this.selectableId.length > 0) {
        this.filteredItems.map((i) => {
          if (i.selectable === false) {
            return;
          }
          const itemId = i[this.itemKey];
          if (itemId !== null && this.selectableId.includes(itemId)) {
            const idx = this.selectedItems.findIndex(
              (x) => x[this.itemKey] === itemId
            );
            if (idx === -1) {
              this.selectedItems.push(i);
            }
            if (!this.selected.includes(itemId)) {
              this.selected.push(itemId);
            }
          }
        });
      }
    },
  },
  created() {
    // always hide columns used internally to track selections
    this.hide.push('selected');
    this.hide.push('selectable');
    this.hide.push('noSelectMessage');

    if (this.selectable && this.itemKey === undefined) {
      console.error(
        `BaseTable: 'selectable' is true but no 'item-key' is set. An item key is required for selections`
      );
    }
  },
  methods: {
    toggleAll() {
      if (this.selectedItems.length > 0) {
        this.selectedItems = [];
      } else if (this.filteredItems.length > this.maxSelections) {
        this.showSnackbar(
          `Woah, that's a lot of items! Please narrow your range to ${this.maxSelections} or less items to select all.`
        );
      } else {
        this.filteredItems.map((i) => {
          if (i.selectable === false) {
            return;
          }
          const itemId = i[this.itemKey];
          if (itemId !== null) {
            this.selectedItems.push(i);
          }
        });
      }
      this.selected =
        this.selectedItems.length > 0
          ? this.selectedItems.map((x) => x[this.itemKey])
          : [];
    },
    toggleItem(item, eventTarget) {
      if (this.isToggleableClickEvent(item, eventTarget)) {
        return;
      }
      const itemId = item[this.itemKey];
      if (this.selected.includes(itemId)) {
        // unselect the item
        const idx = this.selectedItems.findIndex(
          (x) => x[this.itemKey] === itemId
        );
        if (idx !== -1) {
          this.selectedItems.splice(idx, 1);
        }
      } else {
        // select the item
        if (itemId !== null) {
          if (this.selectedItems.length === this.maxSelections) {
            // maximum selection count reached - replace the last selection
            this.selectedItems.pop();
          }
          this.selectedItems.push(item);
        }
      }
      this.selected =
        this.selectedItems.length > 0
          ? this.selectedItems.map((x) => x[this.itemKey])
          : [];
      this.$emit('selectionchange', this.selectedItems);
    },
    isToggleableClickEvent(item, eventTarget) {
      const noSelecting = item.selectable === false || this.disabled === true;
      const isLink = eventTarget instanceof HTMLAnchorElement;
      let isButton = false;
      if (eventTarget) {
        const { type, className } = eventTarget;
        isButton = type === 'button' || className.includes('v-btn');
      }
      return noSelecting || isLink || isButton;
    },
    showSnackbar(msg) {
      this.snackbarMessage = msg;
      this.snackbar = true;
    },
    refreshSelections() {
      this.selectedItems = [];
      this.selected = [];
    },
  },
};
